import { PaymentSession } from 'controllers/types';
import { useKyronQuery } from './kyronQuery';

export const usePaymentSessionQuery = (sessionId?: string) =>
  useKyronQuery<PaymentSession>(`/payments/payment_session?session_id=${sessionId}`, {
    enabled: !!sessionId,
  });

export const usePublishableKeyQuery = () => useKyronQuery<{ publishable_key: string }>('/payments/publishable_key');
